import "core-js/modules/es6.reflect.construct.js";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-tabs.
* homepage: https://github.com/react-component/tabs
*/
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { debounce } from 'lodash-es';
import ResizeObserver from 'resize-observer-polyfill';
import { setTransform, isTransformSupported, requestAnimationFrame } from './utils';
import Icon from '../../wui-icon/src';
import Dropdown from '../../wui-dropdown/src';
import Menu from '../../wui-menu/src';
var Item = Menu.Item;

var ScrollableTabBarNode = /*#__PURE__*/function (_React$Component) {
  _inherits(ScrollableTabBarNode, _React$Component);

  var _super = _createSuper(ScrollableTabBarNode);

  function ScrollableTabBarNode(props) {
    var _this;

    _classCallCheck(this, ScrollableTabBarNode);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (key) {
      // 当选择项时，tabs移动到相应位置
      var tabBarPosition = _this.props.tabBarPosition;

      var navWrapNode = _this.props.getRef('navWrap');

      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);

      var domNode = Array.prototype.slice.call(_this.props.getRef('nav').children[0].children);
      var itemIndex = 0;
      domNode.forEach(function (item, index) {
        console.log(item.getAttribute('nodekey') == key.key);

        if (item.getAttribute('nodekey') == key.key) {
          itemIndex = index;

          if (tabBarPosition === 'left' || tabBarPosition === 'right') {
            _this.setOffset(_this.props.getRef('nav').getBoundingClientRect().top - _this.getTabItemDom(index).getBoundingClientRect().top + navWrapNodeWH - _this.getTabItemDom(index).getBoundingClientRect().height);
          } else {
            _this.setOffset(_this.props.getRef('nav').getBoundingClientRect().left - _this.getTabItemDom(index).getBoundingClientRect().left + navWrapNodeWH - _this.getTabItemDom(index).getBoundingClientRect().width);
          }
        }
      });

      _this.getMenuItem(itemIndex);

      _this.props.onTabClick(key.key);
    });

    _defineProperty(_assertThisInitialized(_this), "prevTransitionEnd", function (e) {
      if (e.propertyName !== 'opacity') {
        return;
      }

      var container = _this.props.getRef('container');

      _this.scrollToActiveTab({
        target: container,
        currentTarget: container
      });
    });

    _defineProperty(_assertThisInitialized(_this), "scrollToActiveTab", function (e) {
      var activeTab = _this.props.getRef('activeTab');

      var navWrap = _this.props.getRef('navWrap');

      if (e && e.target !== e.currentTarget || !activeTab) {
        return;
      } // when not scrollable or enter scrollable first time, don't emit scrolling


      var needToSroll = _this.isNextPrevShown() && _this.lastNextPrevShown;

      _this.lastNextPrevShown = _this.isNextPrevShown();

      if (!needToSroll) {
        return;
      }

      var activeTabWH = _this.getScrollWH(activeTab);

      var navWrapNodeWH = _this.getOffsetWH(navWrap);

      var _assertThisInitialize = _assertThisInitialized(_this),
          offset = _assertThisInitialize.offset;

      var wrapOffset = _this.getOffsetLT(navWrap);

      var activeTabOffset = _this.getOffsetLT(activeTab);

      if (wrapOffset > activeTabOffset) {
        offset += wrapOffset - activeTabOffset;

        _this.setOffset(offset);
      } else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
        offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);

        _this.setOffset(offset);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "prev", function (e) {
      _this.props.onPrevClick(e);

      var navWrapNode = _this.props.getRef('navWrap');

      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);

      var _assertThisInitialize2 = _assertThisInitialized(_this),
          offset = _assertThisInitialize2.offset;

      _this.setOffset(offset + navWrapNodeWH);
    });

    _defineProperty(_assertThisInitialized(_this), "next", function (e) {
      _this.props.onNextClick(e);

      var navWrapNode = _this.props.getRef('navWrap');

      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);

      var _assertThisInitialize3 = _assertThisInitialized(_this),
          offset = _assertThisInitialize3.offset;

      _this.setOffset(offset - navWrapNodeWH);
    });

    _this.offset = 0;
    _this.state = {
      next: false,
      prev: false,
      menuArr: ''
    };
    return _this;
  }

  _createClass(ScrollableTabBarNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.getMenuItem(0);
      }, 500);
      this.componentDidUpdate();
      this.debouncedResize = debounce(function () {
        _this2.setNextPrev();

        _this2.scrollToActiveTab();
      }, 200);
      this.resizeObserver = new ResizeObserver(this.debouncedResize);
      this.resizeObserver.observe(this.props.getRef('container'));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      requestAnimationFrame(function () {
        var props = _this3.props;

        if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
          _this3.setOffset(0);

          return;
        }

        var nextPrev = _this3.setNextPrev(); // wait next, prev show hide

        /* eslint react/no-did-update-set-state:0 */


        if (_this3.isNextPrevShown(_this3.state) !== _this3.isNextPrevShown(nextPrev)) {
          _this3.setState({}, _this3.scrollToActiveTab);
        } else if (!prevProps || props.activeKey !== prevProps.activeKey) {
          // can not use props.activeKey
          _this3.scrollToActiveTab();
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      if (this.debouncedResize && this.debouncedResize.cancel) {
        this.debouncedResize.cancel();
      }
    }
  }, {
    key: "setNextPrev",
    value: function setNextPrev() {
      var navNode = this.props.getRef('nav');
      var navTabsContainer = this.props.getRef('navTabsContainer');
      var navNodeWH = this.getScrollWH(navTabsContainer || navNode); // Add 1px to fix `offsetWidth` with decimal in Chrome not correct handle
      // https://github.com/ant-design/ant-design/issues/13423

      var containerWH = this.getOffsetWH(this.props.getRef('container')) + 1;
      var navWrapNodeWH = this.getOffsetWH(this.props.getRef('navWrap'));
      var offset = this.offset;
      var minOffset = containerWH - navNodeWH;
      var _this$state = this.state,
          next = _this$state.next,
          prev = _this$state.prev;

      if (minOffset >= 0) {
        next = false;
        this.setOffset(0, false);
        offset = 0;
      } else if (minOffset < offset) {
        next = true;
      } else {
        next = false; // Fix https://github.com/ant-design/ant-design/issues/8861
        // Test with container offset which is stable
        // and set the offset of the nav wrap node

        var realOffset = navWrapNodeWH - navNodeWH;
        this.setOffset(realOffset, false);
        offset = realOffset;
      }

      if (offset < 0) {
        prev = true;
      } else {
        prev = false;
      }

      this.setNext(next);
      this.setPrev(prev);
      return {
        next: next,
        prev: prev
      };
    }
  }, {
    key: "getOffsetWH",
    value: function getOffsetWH(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'offsetWidth';

      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'offsetHeight';
      }

      return node[prop];
    }
  }, {
    key: "getScrollWH",
    value: function getScrollWH(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'scrollWidth';

      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'scrollHeight';
      }

      return node[prop];
    }
  }, {
    key: "getOffsetLT",
    value: function getOffsetLT(node) {
      var tabBarPosition = this.props.tabBarPosition;
      var prop = 'left';

      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        prop = 'top';
      }

      return node.getBoundingClientRect()[prop];
    }
  }, {
    key: "setOffset",
    value: function setOffset(offset) {
      var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var target = Math.min(0, offset);

      if (this.offset !== target) {
        this.offset = target;
        var navOffset = {};
        var tabBarPosition = this.props.tabBarPosition;
        var navStyle = this.props.getRef('nav').style;
        var transformSupported = isTransformSupported(navStyle);

        if (tabBarPosition === 'left' || tabBarPosition === 'right') {
          if (transformSupported) {
            navOffset = {
              value: "translate3d(0,".concat(target, "px,0)")
            };
          } else {
            navOffset = {
              name: 'top',
              value: "".concat(target, "px")
            };
          }
        } else if (transformSupported) {
          if (this.props.direction === 'rtl') {
            target = -target;
          }

          navOffset = {
            value: "translate3d(".concat(target, "px,0,0)")
          };
        } else {
          navOffset = {
            name: 'left',
            value: "".concat(target, "px")
          };
        }

        if (transformSupported) {
          setTransform(navStyle, navOffset.value);
        } else {
          navStyle[navOffset.name] = navOffset.value;
        }

        if (checkNextPrev) {
          this.setNextPrev();
        }
      }
    }
  }, {
    key: "getTabItemDom",
    value: function getTabItemDom(i) {
      return this.props.getRef('nav').children[0].children[i];
    }
  }, {
    key: "getMenuCurrentPage",
    value: function getMenuCurrentPage(i, isShowItemWidth) {
      var tabBarPosition = this.props.tabBarPosition;
      var navWrapNode = this.props.getRef('navWrap');
      var navWrapNodeWH = this.getOffsetWH(navWrapNode);
      var menuItem = '';
      var menuItemWH = 0;

      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
        menuItemWH = this.getTabItemDom(i).getBoundingClientRect().height + parseFloat(getComputedStyle(this.getTabItemDom(i), null).marginTop) + parseFloat(getComputedStyle(this.getTabItemDom(i), null).marginBottom);
      } else {
        menuItemWH = this.getTabItemDom(i).getBoundingClientRect().width + parseFloat(getComputedStyle(this.getTabItemDom(i), null).marginRight) + parseFloat(getComputedStyle(this.getTabItemDom(i), null).marginLeft);
      }

      if (isShowItemWidth < navWrapNodeWH - menuItemWH / 2) {
        menuItem = JSON.stringify({
          key: this.getTabItemDom(i).getAttribute('nodekey'),
          title: this.getTabItemDom(i).innerText
        });
      }

      return {
        menuItem: menuItem,
        menuItemWH: menuItemWH
      };
    }
  }, {
    key: "getMenuItem",
    value: function getMenuItem() {
      var itemIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var tabBarPosition = this.props.tabBarPosition;
      var navWrapNode = this.props.getRef('navWrap');
      var navWrapNodeWH = this.getOffsetWH(navWrapNode);
      var domNode = Array.prototype.slice.call(this.props.getRef('nav').children[0].children); // 所有tab项元素的数组集合

      var isShowItemWidth = 0; // 显示的每一项的宽或高总和

      var initFirstPageWidth = 0; // 初始化显示的每一项的宽或高总和

      var isShowArr = []; // 显示项的集合

      var firstPageIndex = []; // 初始化显示项集合

      for (var i = 0; i < domNode.length; i++) {
        // 计算出第一屏显示的项的临界值，firstPageIndex为第一屏下标的数组，用于后面计算目标项是否在第一屏
        if (tabBarPosition === 'left' || tabBarPosition === 'right') {
          initFirstPageWidth += this.getTabItemDom(i).getBoundingClientRect().height + parseFloat(getComputedStyle(this.getTabItemDom(i), null).marginTop) + parseFloat(getComputedStyle(this.getTabItemDom(i), null).marginBottom);
        } else {
          initFirstPageWidth += this.getTabItemDom(i).getBoundingClientRect().width + parseFloat(getComputedStyle(this.getTabItemDom(i), null).marginRight) + parseFloat(getComputedStyle(this.getTabItemDom(i), null).marginLeft);
        }

        if (initFirstPageWidth >= navWrapNodeWH) {
          firstPageIndex = [].concat(_toConsumableArray(firstPageIndex), [i]);
        }
      }

      if (Math.min.apply(Math, _toConsumableArray(firstPageIndex)) > itemIndex) {
        // 当目标项第一屏时，计算当前屏应该展示的项
        for (var _i = 0; _i < domNode.length; _i++) {
          var newVal = this.getMenuCurrentPage(_i, isShowItemWidth);
          isShowItemWidth += newVal.menuItemWH;
          isShowArr = [].concat(_toConsumableArray(isShowArr), [newVal.menuItem]);
        }
      } else {
        for (var _i2 = itemIndex; _i2 >= 0; _i2--) {
          var _newVal = this.getMenuCurrentPage(_i2, isShowItemWidth);

          isShowItemWidth += _newVal.menuItemWH;
          isShowArr = [].concat(_toConsumableArray(isShowArr), [_newVal.menuItem]);
        }
      }

      var dropDownArr = [];
      var atherArr = [];
      domNode.forEach(function (item) {
        atherArr = [].concat(_toConsumableArray(atherArr), [JSON.stringify({
          key: item.getAttribute('nodekey'),
          title: item.innerText
        })]);
      });
      dropDownArr = atherArr.concat(isShowArr).filter(function (v, i, arr) {
        // 计算当前屏展示的项与总项不同的项（这为应放在select中的项）
        return arr.indexOf(v) === arr.lastIndexOf(v);
      });
      var menuArr = dropDownArr.map(function (item) {
        return item && /*#__PURE__*/React.createElement(Item, {
          key: JSON.parse(item).key
        }, JSON.parse(item).title);
      });
      this.setState({
        menuArr: menuArr
      });
    }
  }, {
    key: "setPrev",
    value: function setPrev(v) {
      if (this.state.prev !== v) {
        this.setState({
          prev: v
        });
      }
    }
  }, {
    key: "setNext",
    value: function setNext(v) {
      if (this.state.next !== v) {
        this.setState({
          next: v
        });
      }
    }
  }, {
    key: "isNextPrevShown",
    value: function isNextPrevShown(state) {
      if (state) {
        return state.next || state.prev;
      }

      return this.state.next || this.state.prev;
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames, _classnames2, _classnames3, _classnames4;

      var _this$state2 = this.state,
          next = _this$state2.next,
          prev = _this$state2.prev;
      var _this$props = this.props,
          clsPrefix = _this$props.clsPrefix,
          scrollAnimated = _this$props.scrollAnimated,
          navWrapper = _this$props.navWrapper,
          prevIcon = _this$props.prevIcon,
          nextIcon = _this$props.nextIcon,
          moreType = _this$props.moreType;
      var showNextPrev = prev || next;
      var prevButton = /*#__PURE__*/React.createElement("span", {
        onClick: prev ? this.prev : null,
        unselectable: "unselectable",
        className: classnames((_classnames = {}, _defineProperty(_classnames, "".concat(clsPrefix, "-tab-prev"), 1), _defineProperty(_classnames, "".concat(clsPrefix, "-tab-btn-disabled"), !prev), _defineProperty(_classnames, "".concat(clsPrefix, "-tab-arrow-show"), showNextPrev), _classnames)),
        onTransitionEnd: this.prevTransitionEnd
      }, prevIcon || /*#__PURE__*/React.createElement(Icon, {
        type: "uf-anglepointingtoleft"
      }));
      var nextButton = /*#__PURE__*/React.createElement("span", {
        onClick: next ? this.next : null,
        unselectable: "unselectable",
        className: classnames((_classnames2 = {}, _defineProperty(_classnames2, "".concat(clsPrefix, "-tab-next"), 1), _defineProperty(_classnames2, "".concat(clsPrefix, "-tab-btn-disabled"), !next), _defineProperty(_classnames2, "".concat(clsPrefix, "-tab-arrow-show"), showNextPrev), _classnames2))
      }, nextIcon || /*#__PURE__*/React.createElement(Icon, {
        type: "uf-anglearrowpointingtoright"
      }));
      var menu = /*#__PURE__*/React.createElement(Menu, {
        onSelect: this.onSelect
      }, this.state.menuArr);
      var moreTabsNode = /*#__PURE__*/React.createElement(Dropdown, {
        trigger: ['hover'],
        overlay: menu,
        animation: "slide-up" // onVisibleChange={onVisibleChange}
        ,
        overlayClassName: "".concat(clsPrefix, "-more-select-dropdown")
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-tab-more-select")
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "uf-3dot-h"
      })));
      var navClassName = "".concat(clsPrefix, "-nav");
      var navClasses = classnames((_classnames3 = {}, _defineProperty(_classnames3, navClassName, true), _defineProperty(_classnames3, scrollAnimated ? "".concat(navClassName, "-animated") : "".concat(navClassName, "-no-animated"), true), _classnames3));
      return /*#__PURE__*/React.createElement("div", {
        className: classnames((_classnames4 = {}, _defineProperty(_classnames4, "".concat(clsPrefix, "-nav-container"), 1), _defineProperty(_classnames4, "".concat(clsPrefix, "-nav-container-scrolling"), showNextPrev && moreType === 'moreTabsArrow'), _defineProperty(_classnames4, "".concat(clsPrefix, "-nav-more"), showNextPrev && moreType === 'moreTabsSelect'), _classnames4)),
        key: "container",
        ref: this.props.saveRef('container')
      }, showNextPrev && moreType === 'moreTabsArrow' && prevButton, showNextPrev && moreType === 'moreTabsArrow' && nextButton, showNextPrev && moreType === 'moreTabsSelect' && moreTabsNode, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-nav-wrap"),
        ref: this.props.saveRef('navWrap')
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-nav-scroll")
      }, /*#__PURE__*/React.createElement("div", {
        className: navClasses,
        ref: this.props.saveRef('nav')
      }, navWrapper(this.props.children)))));
    }
  }]);

  return ScrollableTabBarNode;
}(React.Component);

export { ScrollableTabBarNode as default };
ScrollableTabBarNode.propTypes = {
  activeKey: PropTypes.string,
  getRef: PropTypes.func.isRequired,
  saveRef: PropTypes.func.isRequired,
  tabBarPosition: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  clsPrefix: PropTypes.string,
  scrollAnimated: PropTypes.bool,
  onPrevClick: PropTypes.func,
  onNextClick: PropTypes.func,
  navWrapper: PropTypes.func,
  children: PropTypes.node,
  prevIcon: PropTypes.node,
  nextIcon: PropTypes.node,
  direction: PropTypes.node
};
ScrollableTabBarNode.defaultProps = {
  tabBarPosition: 'left',
  clsPrefix: '',
  scrollAnimated: true,
  onPrevClick: function onPrevClick() {},
  onNextClick: function onNextClick() {},
  navWrapper: function navWrapper(ele) {
    return ele;
  }
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tabs/src/ScrollableTabBarNode.js